import { render, staticRenderFns } from "./OrgAdminClubDashboard.vue?vue&type=template&id=85449f44&scoped=true&"
import script from "./OrgAdminClubDashboard.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminClubDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./OrgAdminClubDashboard.vue?vue&type=style&index=0&id=85449f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85449f44",
  null
  
)

export default component.exports